{
  "name": "sankuo",
  "version": "0.6.0",
  "private": true,
  "description": "三國逗陣打：吳蜀聯軍 vs 曹魏的 2.5D 格鬥 MOBA",
  "scripts": {
    "build": "esbuild src/entries/game.ts src/entries/landing.ts src/entries/codex.ts src/entries/admin.ts src/entries/history.ts --bundle --format=iife --sourcemap --target=es2022 --outdir=art/dist",
    "start": "npm run build && node server/server.ts",
    "test": "node tests/run.cjs",
    "typecheck": "tsc -p .",
    "balance": "sh tests/balance.sh"
  },
  "engines": {
    "node": ">=22.18"
  },
  "devDependencies": {
    "@types/node": "^24.19.1",
    "esbuild": "^0.28.2",
    "typescript": "^7.0.2",
    "vitest": "^5.0.3"
  },
  "type": "module"
}
